import React from 'react';
import { MainContainer, MainHeaderContainer } from './components';
export interface PageProps {
  enableHeaderGlobalBar: boolean;
  headerChildren?: React.ReactElement;
  showLeftHandSideNav?: boolean;
}

/**
 * FULL HEADER, LEFT AND RIGHT PANEL LAYOUT (3 COLUMN)
 */
export const PartialHeaderLeftSideNoPanelLayout: React.FC<PageProps> = (
  props: any
) => {
  const { enableHeaderGlobalBar, headerChildren, showLeftHandSideNav } = props;

  return props.children ? (
    <div className={`container--wrapper `}>
      <MainHeaderContainer
        enableHeaderGlobalBar={enableHeaderGlobalBar || false}
        showLeftHandSideNav={showLeftHandSideNav || false}
      >
        {headerChildren}
      </MainHeaderContainer>
      <MainContainer>{props.children}</MainContainer>
    </div>
  ) : null;
};
